<script setup lang="ts">
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '~/constants/website'

const mobileView = useState('mobileView', () => false)

const route = useRoute()
if (route.query.platform) {
  mobileView.value = true
}

const schemaOrg = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  url: 'https://www.kiriminaja.com',
  sameAs: [
    'https://www.facebook.com/kiriminaja/',
    'https://www.linkedin.com/company/kiriminaja',
    'https://www.instagram.com/kiriminaja_official/',
    'https://youtube.com/channel/UC4zrFKGY7YProakHFWid8oQ',
    'https://twitter.com/kiriminajacom/',
    'https://www.tiktok.com/@kiriminajacom',
    GOOGLE_PLAY_URL,
    APP_STORE_URL
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Jl Palagan Tentara Pelajar No. 77',
    addressLocality: 'Sleman',
    addressCountry: 'ID',
    addressRegion: 'D.I Yogyakarta',
    postalCode: '55581'
  },
  alternateName: 'KAJ',
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '6281125209900',
      contactType: 'customer service',
      email: 'support@kiriminaja.com',
      areaServed: 'ID',
      availableLanguage: ['id']
    }
  ],
  description:
    'KiriminAja adalah platform pengiriman barang dan logistik terkemuka di Indonesia yang menyediakan layanan cepat, andal, dan terjangkau untuk kebutuhan pengiriman Anda.',
  email: 'support@kiriminaja.com',
  foundingDate: '2020-12-26',
  legalName: 'PT Selalu Siap Solusi',
  logo: 'https://kiriminaja.com/images/home-v3/share-card-home.png',
  name: 'KiriminAja',
  numberOfEmployees: {
    '@type': 'QuantitativeValue',
    minValue: 50,
    maxValue: 200
  }
}

useHead({
  script: [
    {
      key: 'schema-org-organization',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schemaOrg)
    }
  ]
})
</script>
<template>
  <UiApp>
    <Navbar v-if="!mobileView" />
    <main>
      <NuxtPage />
    </main>
    <Footer v-if="!mobileView" />
  </UiApp>
</template>
